
import { ChangeEvent } from "react";

export interface JournalTextAreaProps {
  value: string;
  onChange: (e: ChangeEvent<HTMLTextAreaElement>) => void;
  disabled?: boolean;
}

export function JournalTextArea({ value, onChange, disabled = false }: JournalTextAreaProps) {
  return (
    <textarea
      className="w-full h-40 p-3 bg-slate-900/50 border border-slate-700 rounded-md text-white resize-none focus:border-blue-500 focus:ring-1 focus:ring-blue-500 focus:outline-none"
      placeholder="Write your thoughts, reflections, and prayers here..."
      value={value}
      onChange={onChange}
      disabled={disabled}
    />
  );
}
